import React from "react";
import StarOutlineIcon from "@material-ui/icons/StarBorder";

import { connect } from "react-redux";

const LoyaltyPoints = ({ points, language }) => {
  return (
    <div
      className="border w-100 row m-0 mt-4"
      style={{ backgroundColor: "white", minHeight: 65, alignItems: "center" }}
    >
      <div className="col-2" style={{ position: "relative" }}>
        <StarOutlineIcon
          className="center-x-y"
          style={{ fontSize: 32, color: "#999" }}
        />
      </div>
      <div
        className={"col-10 py-3 ".concat(
          language == "english" ? "text-left" : "text-right"
        )}
      >
        <p
          style={{
            fontWeight: "bold",
            margin: 0,
          }}
        >
          {language == "english"
            ? `You just received ${points} points!`
            : `لقد حصلت على ${points} نقاط !`}
        </p>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};
export default connect(mapStateToProps)(LoyaltyPoints);
